import React, { useEffect, useState } from "react";
import Hero from "../components/Hero";
import PrizeTracker from "../components/PrizeTracker";
import Leaderboard from "../components/Leaderboard";
import RulesGrid from "../components/RulesGrid";
import IntegrityFooter from "../components/IntegrityFooter";
import { fetchStats } from "../lib/api";

const Home = () => {
    const [stats, setStats] = useState(null);

    useEffect(() => {
        let mounted = true;
        fetchStats()
            .then((s) => mounted && setStats(s))
            .catch((e) => console.error("fetchStats failed", e));
        return () => {
            mounted = false;
        };
    }, []);

    return (
        <div className="min-h-screen bg-[#0B1325]" data-testid="home-page">
            <Hero />
            <PrizeTracker stats={stats} />
            <Leaderboard />
            <RulesGrid />
            <IntegrityFooter />
        </div>
    );
};

export default Home;
